export default __webpack_public_path__ + "static/media/c2.ae65c331.jpg";